"use strict";

var _prism = _interopRequireDefault(require("prism-react-renderer/prism"));

var _prismIncludeLanguages = _interopRequireDefault(require("@theme/prism-include-languages"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
(0, _prismIncludeLanguages.default)(_prism.default);